module.exports = __webpack_public_path__ + "static/media/view4.c759e3fa.jpg";